<template>
  <v-row>
    <v-col cols="12" sm="12">
      <v-expansion-panels v-model="descriptionPanel">
        <a-expansion-panel @change="changePanelState">
          <v-expansion-panel-header>
            {{ $t("agenda.lblDescription") }}
            <template v-slot:actions>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small color="grey" dark icon v-bind="attrs" v-on="on">
                    <v-icon v-if="isDescriptionPanelOpen()"
                      >mdi-chevron-up
                    </v-icon>
                    <v-icon v-else>mdi-chevron-down </v-icon>
                  </v-btn>
                </template>
                <span v-if="isDescriptionPanelOpen()">{{
                  $t("lblCollapse")
                }}</span>
                <span v-else>{{ $t("lblExpand") }}</span>
              </v-tooltip>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div id="description-card">
              <v-row v-if="!enableEditMode">
                <v-col cols="auto">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <a-btn
                        class=""
                        x-small
                        color="secondary"
                        width="24"
                        min-width="24"
                        v-bind="attrs"
                        v-on="on"
                        @click="onDescriptionEdit"
                      >
                        <v-icon size="16" color="neutralGray1">
                          mdi-pencil</v-icon
                        >
                      </a-btn>
                    </template>
                    <span>{{ $t("agenda.tipEditDescription") }}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="11" class="description_edit overflow-auto">
                  <span v-html="displayDescriptionText"></span>
                </v-col>
              </v-row>
              <v-row v-else>
                <ejs-inplaceeditor
                  :locale="locale"
                  ref="rteObj"
                  id="inplace_description_editor"
                  data-underline="false"
                  mode="Inline"
                  editableOn="Click"
                  submitOnEnter="false"
                  type="RTE"
                  :emptyText="$t('agenda.MeetingDesc')"
                  name="rte"
                  :value="meetingDescriptionText"
                  :actionSuccess="actionSuccess"
                  :beginEdit="beforeEdit"
                  :endEdit="afterEdit"
                  :model="rteModel"
                  :disabled="!updateMeetingPermission"
                  actionOnBlur="ignore"
                  :change="change"
                  :cancelClick="cancelClick"
                  :enableEditMode="enableEditMode"
                  :submitClick="submitClick"
                  :created="onEditorCreated"
                >
                </ejs-inplaceeditor>
                
              </v-row>
              <div v-if="errorMessage" style="margin-top: 8px;">
                  <span style="color: var(--v-error-base) !important">{{
                  errorMessage
                }}</span>
                </div>
              <div v-if="isImagePresent" style="margin-top: 8px;">
                <span style="color: var(--v-error-base) !important">{{
                  $t("imageFormatAllowed")
                }}</span>
              </div>
            </div>
            <v-row v-if="updateMeetingPermission" class="mt-3">
              <v-col cols="6">
                <form ref="generalFileInput">
                  <upload-file
                    :files="descriptionFile"
                    :icons="fileIcons"
                    :rules="[]"
                    :clearList="true"
                    @add-files="addUploadingFiles"
                    @remove-file="removeUploadingFile"
                    :accept="desc_file_types"
                    :hideDetails="false"
                    :chunkUploadFilesList="chunkUploadFilesList"
                    @chunk-upload="onUpdateChunkUpload"
                    :chunkUpload="true"
                  ></upload-file>
                </form>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="12">
                <span
                  v-if="errorCount > 0"
                  class="error--text"
                  style="
                    font-family: 'Noto Sans JP';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 18px;
                  "
                  ><small>{{
                    $t("documents.invalidFileMsg", { count: errorCount })
                  }}</small></span
                >
                <div v-if="!showGeneralDocs.length">
                  <span>{{ $t("agenda.noMeetingMinutesDocument") }}</span>
                </div>
                <v-list
                  dense
                  v-else-if="showGeneralDocs.length > 0"
                  class="file-list"
                >
                  <v-list-item
                    dense
                    v-for="(file, index) in showGeneralDocs"
                    :key="index"
                    link
                    class="pt-0 pb-0"
                  >
                    <v-list-item-content
                      @click="
                        openMeetingDocumentPermission
                          ? documentDownload(file)
                          : ''
                      "
                    >
                      <v-list-item-title
                        style="line-height: 20px"
                        :class="[
                          openMeetingDocumentPermission ? 'downloadLink' : '',
                          'label-m',
                        ]"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              style="display: inline; color: #006cad"
                            >
                              {{ file.fileName }}
                            </div>
                          </template>
                          <p class="ma-0">
                            {{ $t("lblFileName") }} : {{ file.fileName }}
                          </p>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action style="flex-direction: row">
                      <v-tooltip bottom v-if="openMeetingDocumentPermission">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            icon
                            right
                            color="neutralGray1"
                            @click="saveGeneralDocs(file)"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-3"
                            ><v-icon size="24"> mdi-download</v-icon></v-btn
                          >
                        </template>
                        <span>{{ $t("agenda.tipSaveDoc") }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="updateMeetingPermission">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-if="updateMeetingPermission"
                            x-small
                            color="neutralGray1"
                            icon
                            right
                            @click="deleteGeneralDocs(file)"
                            v-bind="attrs"
                            v-on="on"
                            ><v-icon size="24"> mdi-delete</v-icon></v-btn
                          >
                        </template>
                        <span>{{ $t("agenda.tipDeleteDoc") }}</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </a-expansion-panel>
      </v-expansion-panels>
    </v-col>
    <v-col cols="12" sm="12">
      <agenda-table-new
        v-if="meetingObject"
        :selectedMeeting="meetingObject"
        :attendanceRows="attendanceRows"
        :abstractRows="abstractRows"
      ></agenda-table-new>
    </v-col>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </v-row>
</template>

<script>
import Vue from "vue";
import UploadFile from "../documents/UploadFile.vue";
import { InPlaceEditorPlugin, Rte } from "@syncfusion/ej2-vue-inplace-editor";
import MeetingTimerChart from "@/components/agenda/MeetingTimerChart.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import {
  createUUID,
  openDocument,
  formatBytes,
  currentDateTime,
} from "../../utils/util";
import { MAX_UPLOAD_SIZE, fileIcons, DESCRIPTION_LENGTH_10000 } from "../../utils/constant";
import _ from "lodash";
import AgendaPage from "@/components/agenda/agendaPage.vue";
import AgendaTable from "@/components/agenda/agendaTable.vue";
import { L10n } from "@syncfusion/ej2-base";
import * as localeText from "@/Langs/locale.json";
L10n.load(localeText.default);
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Count,
  HtmlEditor,
  QuickToolbar,
  Table,
} from "@syncfusion/ej2-vue-richtexteditor";
import AgendaTableNew from "./agendaTableNew.vue";
import tenantConfigService from "../../api/tenantConfigService";
Vue.use(InPlaceEditorPlugin);
export default {
  name: "MeetingDetailsRightPanelTemplate",
  data: function () {
    return {
      chunkUploadFilesList: [],
      fileIcons,
      enableEditMode: false,
      documents: [],
      descriptionFile: [],
      showGeneralDocs: [],
      generalDocuments: [],
      desc_file_types: [
        "audio/m4a",
        "audio/x-m4a",
        "audio/aac",
        "video/x-msvideo",
        "audio/mpeg",
        "video/mp4",
        "video/mpeg",
        "video/ogg",
        "audio/ogg",
        "audio/wav",
        "audio/webm",
        "video/webm",
        "video/3gpp",
        "audio/3gpp",
        "image/png",
        "audio/mp3",
        "audio/mpeg",
        "audio/x-m4a",
        "image/jpeg",
        "image/gif",
        "image/bmp",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-fontobject",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "text/plain",
        "application/vnd.ms-excel.sheet.macroEnabled.12"
      ],
      isImagePresent: false,
      rteDescriptionObj: null,
      descriptionPanel: null,
      data: {
        data: {},
        dialogMeeting: false,

        topicCategories: [
          { order: 1, name: "Items For Approval", value: "A" },
          { order: 2, name: "Items For Discussion", value: "S" },
          { order: 3, name: "Regular Reporting Items", value: "R" },
        ],
      },

      rteModel: {
        insertImageSettings: {
          allowedTypes: [".jpeg", ".jpg", ".png"],
          display: "inline",
          width: "auto",
          height: "auto",
          saveFormat: "Blob",
        },
        toolbarSettings: {
          enableFloating: false,
          items: [
            "Bold",
            "Italic",
            "Underline",
            "StrikeThrough",
            "FontName",
            "FontSize",
            "FontColor",
            "BackgroundColor",
            "LowerCase",
            "UpperCase",
            "SuperScript",
            "SubScript",
            "|",
            "Formats",
            "Alignments",
            "NumberFormatList",
            "BulletFormatList",
            "Outdent",
            "Indent",
            "|",
            "CreateTable",
            "Image",
            "|",
            "Undo",
            "Redo",
          ],
        },
        quickToolbarSettings: {
          table: [
            "TableHeader",
            "TableRows",
            "TableColumns",
            "TableCell",
            "-",
            "BackgroundColor",
            "TableRemove",
            "TableCellVerticalAlign",
            "Styles",
          ],
        },
      },
      errorMessage: "",
      showCharCount: true,
      maxLength: DESCRIPTION_LENGTH_10000,
      canUpdateDescription: false,
      isExpanded: false,
      dialogPresentor: false,
      selectedParticipantList: [],
      displayMessage: false,
      message: "",
      messageType: "",
      agendaFormData: {
        id: "",
        agendaName: "",
        category: "",
        meetingType: "",
        priority: "",
        frequency: "",
        resolutionType: "",
        topics: [],
        tenantid: sessionStorage.getItem("tenantId"),
        memo: "",
      },
      dialogAgenda: false,
      newAgendaObjectList: [],
      meetingObj: null,
      isMeetingDescriptionPanelOpen: false
    };
  },
  props: {
    selectedMeeting: Object,
    attendanceRows: Number,
    abstractRows: Number,
  },

  components: {
    MeetingTimerChart,
    ConfirmDialog,
    MessageSheet,
    AgendaPage,
    AgendaTable,
    AgendaTableNew,
    UploadFile,
  },
  provide: {
    inplaceeditor: [Rte],
  },
  created() {
    this.$root.$off("refresh-meeting");
    this.tenantid = localStorage.getItem('tenantId')
  },
  async mounted() {
    const configList = await tenantConfigService.getTenantConfigList();
    const defaultFoldingConfig = configList.find(config => config.configname === "defaultFolding");

    if (defaultFoldingConfig && Array.isArray(defaultFoldingConfig.defaultFolding)) {
      const meetingDescConfig = defaultFoldingConfig.defaultFolding.find(item => item.item === "Meeting Description");
      if (meetingDescConfig) {
        this.isMeetingDescriptionPanelOpen = meetingDescConfig.folded || false;
      }
    }
    const isPanelOpen = this.isMeetingDescriptionPanelOpen ? 0 : null
    this.descriptionPanel = isPanelOpen
    //this.meetingObj = this.selectedMeeting;
    let docs = [];
    if (this.selectedMeeting.generalMeetingDocs) {
      docs = this.selectedMeeting.generalMeetingDocs.map((i) => {
        i.isUploaded = true;
        return i;
      });
    }
    this.showGeneralDocs = docs;
    this.$root.$on("refresh-meeting", (obj) => {
      this.meetingObject = obj;
    });
  },
  beforeDestroy() {
    this.$root.$off("refresh-meeting");
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    ...mapState({
      agendaListData: (state) => state.agenda.agendaList,
      getCachedUser: (state) => state.people.userList,
    }),
    ...gettersMap(),

    meetingObject: {
      get() {
        const meetingData = this.meetingObj
          ? this.meetingObj
          : this.selectedMeeting;
        return meetingData;
      },
      set(val) {
        this.meetingObj = val;
      },
    },
    displayDescriptionText() {
      const result = trimHtml(this.meetingDescriptionText);
      return this.meetingDescriptionText && result !== ""
        ? result
        : this.$t("agenda.MeetingDesc");
    },
    meetingDescriptionText: {
      get() {
        return this.meetingObject.description;
      },
      set(val) {
        if (val != this.meetingObject.description) {
          const result = trimHtml(val);
          this.meetingObject.description = result;
          this.$eventHub.$emit("onMeetingUpdate");
        }
      },
    },
    topics() {
      if (!this.meetingObject.topics) {
        return [];
      }
      let data = this.meetingObject.topics.map((item) => ({
        ...item,
        agenda: this.agendaListData.filter((f) => f.id === item.agendaId)[0]
          ? this.agendaListData.filter((f) => f.id === item.agendaId)[0]
          : this.newAgendaObjectList.filter((f) => f.id === item.agendaId)[0],
      }));
      return data.filter((f) => f.agenda);
    },
    enableDescription() {
      return this.canUpdateDescription;
    },

    topicHeaders() {
      return [
        {
          align: " d-none",
          text: "Agenda Title",
          value: "agenda.agendaName",
          sortable: false,
        },
        {
          text: "Agenda & Topics",
          align: "start",
          value: "topicName",
          sortable: false,
          groupable: false,
        },

        {
          align: "start",
          text: "Category",
          value: "topicCategory",
          groupable: true,
          sortable: false,
        },
        {
          align: "start",
          text: "Priority",
          value: "agenda.priority",
          width: 80,
          groupable: false,
          sortable: false,
        },
        {
          align: "start",
          text: "Scheduled Time",
          value: "timeInMinutes",
          width: 80,
          groupable: false,
          sortable: false,
        },
        {
          align: " d-none",
          text: "Actual Time",
          value: "actualTime",
          class: "appBar",
          sortable: false,
          groupable: false,
        },
        {
          align: "start",
          text: "Presentor",
          value: "peopleInCharge",
          class: "presentorHeader",
          sortable: false,
          groupable: false,
        },
        {
          align: "start",
          text: "Documents",
          value: "documents",
          groupable: false,
          sortable: false,
        },
      ];
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    messageDownloadURL() {
      return (
        process.env.VUE_APP_CONVOCATION_SERVICE +
        "convocation/" +
        this.meetingObject.id
      );
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
    openMeetingDocumentPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "OpenMeetingDocument"
        );
      }
      return false;
    },
    errorCount() {
      let count = 0;
      for (const item of this.descriptionFile) {
        if (this.checkStatus(item).status === false) {
          count++;
        }
      }
      return count;
    },
  },
  watch: {
    isImagePresent(val) {
      let descriptionSaveBtn = document.getElementsByClassName("e-btn-save");
      if (descriptionSaveBtn.length) {
        descriptionSaveBtn[0].disabled = val;
      }
      this.$emit("descriptionWithImg", val);
    },
    descriptionFile: {
      immediate: true,
      async handler() {
        if (this.descriptionFile.length) {
          this.checkGeneralFiles();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      deleteDocuments: "document/deleteDocuments",
      createDocuments: "document/createDocuments",
      updateMeetingData: "meeting/updateMeeting",
      getMeetingDetails: "meeting/getMeetingById",
      getDocumentsByMeetingId: "document/getDocumentsByMeetingId",
      getConvocation: "meeting/getConvocationById",
      downloadConvocationMessageAPI: "meeting/downloadConvocationMessage",
      downloadDocumentAPI: "document/downloadDocument",
    }),
     onEditorCreated() {
      // Delay to ensure DOM is available
      this.$nextTick(() => {
        setTimeout(() => {
          const editorDiv = document.querySelector('#rte_editor_rte-edit-view');
          if (editorDiv) {
            editorDiv.addEventListener('keyup', this.onKeyupValidate);
            this.onKeyupValidate(); // Initial validation
          }
        }, 100);
      });
    },

    onKeyupValidate() {
      const editorDiv = document.querySelector('#rte_editor_rte-edit-view');
      if (!editorDiv) return;

      const text = editorDiv.innerText.trim();
      if (text.length > this.maxLength) {
        this.errorMessage = this.$t("ruleMaxText", {maxLength: this.maxLength}) ;
      } else {
        this.errorMessage = '';
      }
      this.toggleSaveButton(text.length);
    },

    toggleSaveButton(textLength) {
      const saveBtn = document.querySelector(
        '#inplace_description_editor .e-editable-action-buttons .e-btn-save'
      );
      if (saveBtn) {
        if (textLength > this.maxLength) {
          saveBtn.setAttribute('disabled', 'true');
        } else {
          saveBtn.removeAttribute('disabled');
        }
      }
    },

    actionSuccess: function (args) {
      var val = args.value;
      args.value = val;
      this.meetingDescriptionText = val;
    },
    currentDateTime,
    formatBytes,
    onUpdateChunkUpload(params) {
      const index = this.chunkUploadFilesList.findIndex(
        (item) => item.fileName === params.fileName
      );
      if (params.isChunkUpload) {
        if (index === -1) {
          this.chunkUploadFilesList.push(params);
        }
      } else {
        if (index !== -1) {
          this.chunkUploadFilesList.splice(index, 1);
        }
      }
      this.checkGeneralFiles();
    },
    checkGeneralFiles() {
      let isFilesValid = this.descriptionFile.every(
        (file) => this.checkStatus(file).status === true
      );
      if (this.descriptionFile.length) {
        this.$eventHub.$emit("onMeetingUpdate");
        this.$eventHub.$emit(
          "onGeneralFileUpload",
          this.descriptionFile,
          isFilesValid,
          this.chunkUploadFilesList
        );
      }
    },
    onDescriptionEdit() {
      this.enableEditMode = true;
    },
    async saveGeneralDocs(item) {
      const params = {
        documentId: item.documentId,
        filename: item.fileName,
      };
      const res = await this.downloadDocumentAPI(params);
      var contentType = res.headers["content-type"];
      var blob = new Blob([res.data], { type: contentType });
      var url = window.URL.createObjectURL(blob);
      this.downloadMessage(url, item.fileName);
    },
    async deleteGeneralDocs(item) {
      const answer = await this.ConfirmDelete();
      if (answer) {
        if (item.documentId) {
          this.meetingObject.generalMeetingDocs.map((doc, i) => {
            if (item.documentId === doc.documentId) {
              this.showGeneralDocs.splice(i, 1);
              this.meetingObject.generalMeetingDocs.splice(i, 1);
            }
          });
          this.$eventHub.$emit("onMeetingUpdate");
          this.$eventHub.$emit("onDeleteDocuments", item.documentId);
        }
      }
    },
    removeUploadingFile(index) {
      this.descriptionFile.splice(index, 1);
    },
    checkStatus(file) {
      const maxSize = MAX_UPLOAD_SIZE ?? 0;
      let filesWithStatus = {
        filename: file.name,
      };
      if (!this.desc_file_types.includes(file.type)) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileErrorMsg", {
          filename: file.name,
        });
      } else if (file.size > maxSize) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileSizeErrorMsg", {
          maxsize: formatBytes(maxSize),
        });
      } else {
        filesWithStatus.status = true;
        filesWithStatus.message = "Success";
      }
      return filesWithStatus;
    },
    addUploadingFiles(files) {
      files = Array.from(files);
      this.descriptionFile.push(...files);
    },
    isDescriptionPanelOpen() {
      if (this.descriptionPanel || this.descriptionPanel == 0) {
        return this.descriptionPanel.toString();
      }
    },
    changePanelState() {
      setTimeout(() => {
        if (this.$refs.rteObj) {
          this.rteDescriptionObj = this.$refs.rteObj.ej2Instances;
          this.rteDescriptionObj.editIcon.title = this.$t(
            "people.tipUpdateDescription"
          );
        }
      }, 100);
    },
    cancelClick() {
      this.enableEditMode = false;
      this.isDescriptionInvalidImage(this.meetingDescriptionText);
      this.errorMessage = '';
    },
    submitClick() {
      this.enableEditMode = false;
    },
    async change(args) {
      this.isDescriptionInvalidImage(args.value);
    },
    beforeEdit() {
      document.getElementById("description-card").style.paddingBottom = "3%";
    },
    afterEdit() {
      if (this.rteDescriptionObj && this.rteDescriptionObj.editIcon) {
        this.rteDescriptionObj.editIcon.title = this.$t(
          "people.tipUpdateDescription"
        );
      }

      document.getElementById("description-card").style.paddingBottom = "16px";
    },
    editDescriptionToggle() {
      this.canUpdateDescription = !this.canUpdateDescription;
      //this.$refs.rteObj.ej2Instances.disabled =  this.cannotUpdateDescription;
      // this.$refs.rteObj.ej2Instances.enabled = !this.cannotUpdateDescription;
    },
    fullscreenTimer() {
      //this.$router.push("/meetingTimer/"+this.meetingObject.id);
      var height = screen.height;
      var width = screen.width;
      var strWindowFeatures =
        "location=yes,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: "/meetingTimer/" + this.meetingObject.id,
      });
      var popup = window.open(routeData.href, "_blank", strWindowFeatures);
      popup.moveTo(0, 0);
    },
    onChangePresentor(topic) {
      let meetTopic = this.meetingObject.topics.find(
        (s) =>
          String(s.topicName).toLowerCase() ===
          String(topic.topicName).toLowerCase()
      );
      if (meetTopic) {
        meetTopic.peopleInCharge = topic.peopleInCharge;

        this.$eventHub.$emit("onMeetingUpdate");
      }
    },

    createMeetingAgenda(agendaObject) {
      agendaObject.meetingType = this.meetingObject.meetingType;
      this.newAgendaObjectList.push({ ...agendaObject });
      this.$eventHub.$emit("onNewAgenda", this.newAgendaObjectList);
      agendaObject.topics.forEach((topic) => {
        this.meetingObject.topics.push({ ...topic });
      });
    },
    ExpandCollapse(isExpanded) {
      this.isExpanded = isExpanded;
      this.$eventHub.$emit("onExpandCollapseClick", isExpanded);
    },

    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },

    addDropFile(e, item) {
      this.filesChange(e.dataTransfer.files, item);
    },
    filesChange(fileList, rowData) {
      let formData;
      Array.from(Array(fileList.length).keys()).map(async (x) => {
        const newDocObj = {
          documentId: null,
          tenantid: this.selectedTenant,
          topicId: rowData.Id,
          meetingid: this.meetingObject.id,
          agendaid: rowData.agendaId,
          directoryid: "",
          peopleid: "",
          fileName: "",
          mimetype: "",
          formData: null,
          action: "add",
        };

        let documentId = createUUID();
        formData = new FormData();
        formData.append("tenantId", this.selectedTenant);
        formData.append("topicId", rowData.Id);
        formData.append("documentId", documentId);
        formData.append("meetingId", this.meetingObject.id);
        formData.append("agendaId", rowData.agendaId);
        formData.append("directoryId", "");
        formData.append("peopleId", "");
        formData.append("attachment", fileList[x]);

        newDocObj.formData = formData;

        newDocObj.documentId = documentId;
        newDocObj.fileName = fileList[x].name;
        newDocObj.mimetype = fileList[x].type;

        rowData.documents.push(newDocObj);
      });
      this.$eventHub.$emit("onMeetingUpdate");
    },
    async documentDownload(item) {
      if (item.action === "add") {
        this.showMessageSheet(this.$t("agenda.CannotOpenDocInfo"), "info");
      } else {
        const params = {
          documentId: item.documentId,
          filename: item.fileName,
        };
        const res = await this.downloadDocumentAPI(params);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        openDocument(url, item.fileName);
      }
    },
    onBlur: function (e) {
      this.$refs.rteObj.ej2Instances.toolbarSettings.enable = false;
    },
    onFocus: function (e) {
      this.$refs.rteObj.ej2Instances.toolbarSettings.enable = true;
    },
    async OpenAllDocs() {
      const documentsList = await this.getDocumentsByMeetingId(
        this.meetingObject.id
      );
      documentsList.forEach(async (file) => {
        const res = await this.downloadDocumentAPI(file.id);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    },

    createAgenda() {
      this.agendaFormData = {
        id: "",
        agendaName: "",
        category: "",
        meetingType: this.meetingTypesList.find(
          (c) =>
            String(c.label).toLowerCase() ===
            String(this.meetingObject.meetingType).toLowerCase()
        ) || { label: this.meetingObject.meetingType, color: "#F5CBA7" },
        priority: "",
        frequency: "",
        resolutionType: "",
        topics: [],
        tenantid: this.selectedTenant,
        memo: "",
      };
      this.dialogAgenda = true;
    },
    async OpenAllDocuments() {
      if (this.topics.length > 0) {
        this.topics.forEach((topic) => {
          if (topic.documents.length > 0) {
            topic.documents.forEach(async (document) => {
              const res = await this.downloadDocumentAPI(document.documentId);
              var contentType = res.headers["content-type"];
              var blob = new Blob([res.data], { type: contentType });
              var url = window.URL.createObjectURL(blob);
              window.open(url);
            });
          }
        });
      }
    },

    async downloadConvocation() {
      //const convocationStream = await this.getConvocation(this.meetingObject.id);
      //var sampleBytes = this.fromBinary(convocationStream);
      const res = await this.downloadConvocationMessageAPI(
        this.meetingObject.id
      );
      var contentType = res.headers["content-type"];
      var blob = new Blob([res.data], { type: contentType });
      var url = window.URL.createObjectURL(blob);

      this.downloadMessage(url, [this.meetingObject.meetingName + ".msg"]);

      this.showMessageSheet(this.$t("agenda.ConvoEmailDownloaded"), "success");
    },

    downloadMessage(url, name) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    base64ToArrayBuffer(base64) {
      //var binaryString =  window.atob(base64);

      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index == "topicCategory") {
          let x = this.getTopicCategoryOrder(a[index]);
          let y = this.getTopicCategoryOrder(b[index]);
          if (!isDesc) {
            return x > y ? -1 : 1;
          } else {
            return y > x ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    getDay(meetingdate) {
      if (meetingdate === null) {
        return "";
      }
      var Xmas95 = new Date(meetingdate);
      //alert(this.selectedLang);
      var options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
      return Xmas95;
    },
    getTopicCategoryText(cat) {
      //let categoryVal = cat.charAt(0);
      return this.data.topicCategories.find((v) => v.value === cat).name;
    },
    getTopicCategoryOrder(cat) {
      //let categoryVal = cat.charAt(0);
      return this.data.topicCategories.find((v) => v.value === cat).order;
    },
    getPresentor(picID) {
      let pic = this.meetingObject.attendees.find(
        (a) => String(a.id).toLowerCase() === String(picID).toLowerCase().trim()
      );
      if (pic) {
        return pic;
      }
      return picID;
    },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
      }, {});
    },
    deleteDocument,
    ConfirmDelete,
    alertDialog,
    createUUID,
    updateMeeting,
    isDescriptionInvalidImage,
  },
};

async function isDescriptionInvalidImage(htmlContent) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const imgTags = Array.from(doc.querySelectorAll("img")); // Collect img tags as an array

  // Process all img tags
  this.isImagePresent = false;
  for (const imgTag of imgTags) {
    const imgSrc = imgTag.getAttribute("src");
    if (imgSrc && !imgSrc.startsWith("IMAGE_") && !imgSrc.startsWith("data:")) {
      const response = await fetch(imgSrc);
      const blob = await response.blob();
      const isImage = blob.type.startsWith("image/");
      if (!isImage) {
        this.isImagePresent = true;
      }
    }
  }
  if (imgTags.length === 0) {
    this.isImagePresent = false;
  }
}

async function updateMeeting() {
  const updatedMeetingObj = await this.getMeetingDetails(this.meetingObject.id);

  updatedMeetingObj.topics = this.meetingObject.topics;

  this.updateMeetingData(updatedMeetingObj).then((response) => {});
}

async function deleteDocument(item, rowData) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    if (item.documentId) {
      for (var i = 0; i < rowData.documents.length; i++) {
        var obj = rowData.documents[i];
        if (item.documentId === obj.documentId) {
          rowData.documents.splice(i, 1);
          i--;
        }
      }
      this.$eventHub.$emit("onMeetingUpdate");
      this.$eventHub.$emit("onDeleteDocuments", item.documentId);
    }
  }
}

async function ConfirmDelete() {
  if (
    await this.$refs.confirm.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}

async function alertDialog() {
  if (
    await this.$refs.confirm.open(
      this.$t("Alert"),
      this.$t("agenda.CannotDownloadAlert"),
      { noconfirm: true }
    )
  ) {
    return true;
  }
}

function gettersMap() {
  return mapGetters({
    meetingTypesList: "tenant/agendaMeetingTypes",
    getMeetingTypeId: "meeting/getMeetingTypeId",
  });
}

function trimHtml(html) {
  // Remove excessive &nbsp;
  let cleaned = html.replace(/(&nbsp;|\s)+/g, " ");

  // Parse the HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(cleaned, "text/html");

  // Serialize back to string
  return doc.body.innerHTML.trim();
}
</script>

<style scoped>
::v-deep pre {
  width: 100% !important;
  overflow: auto !important;
}
.chk-hunk-upload {
  margin-left: -3px !important;
}
::v-deep .chk-hunk-upload.v-input .v-label {
  font-size: 13px !important;
}
::v-deep .chk-hunk-upload.v-input .v-input--selection-controls__input {
  margin-right: 2px !important;
}
.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(
    .v-expansion-panel-header__icon--disable-rotate
  )
  .v-icon {
  transform: rotate(0deg) !important;
}
.e-inplaceeditor {
  width: 100% !important;
}

.presentorHeader {
  text-align: center !important;
}
::v-deep .v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 0px;
}

::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  /* box-shadow: none !important; */
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0px;
}

::v-deep .inputfile + label {
  border: dashed 1px lightgray;
  border-radius: 3;
  color: darkgray;
  display: inline-block;
  min-width: 250px;
}

::v-deep .inputfile:focus + label,
.inputfile + label:hover {
  background-color: var(--v-warning-lighten4);
  cursor: pointer; /* "hand" cursor */
}

::v-deep .downloadLink:hover {
  color: var(--v-primary-darken1);
  cursor: pointer; /* "hand" cursor */
}

::v-deep .richTextBox {
  opacity: 3.5 !important;
}

.description_edit:hover {
  background-color: #f5f5f5;
  border-radius: 2px;
}
</style>